<script context="module">
	export const name = "Grilă";
</script>

<script>
	// wrapper-less: items flow straight into the parent BlockContainer grid
	import ContentItem from "@reperio-news/core.components/blocks/ContentItem/View.svelte";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	$: items = (data && data.content && data.content.items) || [];
</script>

{#each items as item, index (item.id || index)}
	<ContentItem
		data={{ content: item, layout: data.content_layout || "default", custom_fields: data.content_custom_fields }}
		indexInContainer={[index, items.length]}
	/>
{/each}
